export default __webpack_public_path__ + "static/media/acms-project.bd9013b8.svg";